import { DataTableMeta, DateColumn, LimitedContent } from '@otp/ui';
import { TFunction } from 'i18next';
import React from 'react';

import { ActionsColumn } from '../table/columns/actions';
import { WttpTemplateAction } from '../table/columns/actions/actions-modals';
import { PartialTemplateType } from 'src/components/wttp/templates/types';
import { StatusColumn } from 'src/components/wttp/common/table/columns/status';

export const getTableConfig = (
  wttpTemplates: PartialTemplateType[],
  {
    t,
    onActionFinished,
    isGlobalTemplatesOnly,
  }: {
    t: TFunction;
    onActionFinished?: (action: WttpTemplateAction) => void;
    isGlobalTemplatesOnly: boolean;
  },
) => [
  {
    name: 'isActive',
    label: t('common.status.label'),
    options: {
      customBodyRender: (isActive: boolean, column: DataTableMeta) => {
        const wttpTemplate = wttpTemplates[column.rowIndex];

        return (
          <StatusColumn status={wttpTemplate.status} isActive={isActive} />
        );
      },
    },
  },
  {
    name: 'name',
    label: t('common.name'),
  },
  {
    name: 'description',
    label: t('common.description'),
    options: {
      customBodyRender: (value: string) => {
        return <LimitedContent maxRows={2}>{value}</LimitedContent>;
      },
    },
  },
  {
    name: 'usedByStoreCount',
    label: t('wttp.template.list.used-by'),
  },
  {
    name: 'createdAt',
    label: t('common.created-at'),
    options: {
      customBodyRender: (value: string) => <DateColumn date={value} />,
      isDesktopOnly: true,
    },
  },
  {
    name: 'updatedAt',
    label: t('common.updated-at'),
    options: {
      customBodyRender: (value: string) => <DateColumn date={value} />,
    },
  },
  {
    name: 'actions',
    label: t('common.actions'),
    options: {
      customBodyRender: (_: any, column: DataTableMeta) => {
        const wttpTemplate = wttpTemplates[column.rowIndex];

        return (
          <ActionsColumn
            wttpTemplate={wttpTemplate}
            onActionFinished={onActionFinished}
            isGlobalTemplatesOnly={isGlobalTemplatesOnly}
          />
        );
      },
    },
  },
];
